import {GraphQLQuery,} from '@aws-amplify/api';
import {generateClient} from "aws-amplify/api";
import {Account} from "../../types.ts";
import {createCustomer, setAccountCustomerId} from "./mutations.ts";

export type Customer = {
    id: string,
    name: string,
}

export type CreateCustomer = {
    createCustomer: Customer
}

export type SetAccountCustomerId = {
    setAccountCustomerId: { id: string, customerId: string | null, updated: string }
}


const client = generateClient();


export const saveCustomer = async (account: Account) => {
    const response = await client.graphql<GraphQLQuery<CreateCustomer>>({
                                                                            query: createCustomer,
                                                                            variables: {
                                                                                input: {
                                                                                    name: account.email,
                                                                                    description: `Customer account for ${account.email}`,
                                                                                    status: 'Active',
                                                                                    billingInfo: {
                                                                                        billingProviderId: '2ec65b2a-0741-4369-92ea-bc50fabe8b8f',
                                                                                    }
                                                                                }
                                                                            },
                                                                        });
    return response.data?.createCustomer;
};

// FNP-575: re-assign which Customer this account owns (re-points ownerAccountId,
// the FNP-121 deletion-cascade key). setAccountCustomerId is the single writer —
// an idempotent SET that overwrites a stale/dangling customerId; the linkage event
// then flows through the seam to update the billing projection. Admin-only.
export const reassignAccountCustomer = async (accountId: string, customerId: string) => {
    const response = await client.graphql<GraphQLQuery<SetAccountCustomerId>>({
                                                                                  query: setAccountCustomerId,
                                                                                  variables: {input: {id: accountId, customerId}},
                                                                              });
    return response.data?.setAccountCustomerId;
};
